import { stepConfigItem } from './types';

const stepsSchemaCz: stepConfigItem[] = [
  {
    id: 'dietType',
    slug: 'diet-type',
  },
  { id: 'summary', slug: 'summary' },
];

export default stepsSchemaCz;
